import React, { useCallback } from 'react';
import * as Styled from './ActionItem.styled';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  ChatSidebarTabs,
  ChatStates,
  setChatSidebarTab,
  setPendingAction,
  setVisibleAction,
} from '../../slices/chat/ChatSlice';
import LoadingIcon from '../atoms/LoadingIcon/LoadingIcon';
import { useTranslation } from 'react-i18next';

const ActionItem = (props) => {
  const chatState = useSelector((state) => state.chat.chatState);
  const pendingAction = useSelector((state) => state.chat?.pendingAction);
  const dispatch = useDispatch();
  const isPending = pendingAction?.id === props.action?.id;

  const handlePerformClick = useCallback(() => {
    dispatch(setPendingAction(props.action));
    dispatch(setVisibleAction(props.action));
    dispatch(setChatSidebarTab(ChatSidebarTabs.RESULTS.ID));
  }, [dispatch, props.action]);

  const { t } = useTranslation();

  return (
    <Styled.ActionItem indentLevel={props.indentLevel}>
      <Styled.ActionItemLabel>{props.title}</Styled.ActionItemLabel>
      <Styled.ActionItemButton
        disabled={chatState !== ChatStates.TALK || !!pendingAction}
        onClick={handlePerformClick}
      >
        {isPending ? <LoadingIcon /> : <span>{t('perform')}</span>}
      </Styled.ActionItemButton>
    </Styled.ActionItem>
  );
};

ActionItem.propTypes = {
  indentLevel: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  action: PropTypes.object.isRequired,
};

export default ActionItem;
